module.exports = __webpack_public_path__ + "img/ic-saved-gift.4e1fc550.svg";